<button [ngClass]="brandService.brand + '-loading'">
  <div class="spans">
    <span></span>
    <span></span>
    <span></span>
  </div>
</button>
